import { isMobile } from '../../../../core/helpers/isMobile';
import { ColumnsType } from '../../../../core/constants/columnsType';
import { popupStore } from '../../../../store/popupStore';
import { PopupTypes } from '../../../../core/constants/popupTypes';
import { checkHashStore } from '../../../../store/checkHashStore';
import { TranslationKeys } from '../../../../core/constants/translationKeys';
import { userInfoStore } from '../../../../store/userInfoStore';
import { isPG, isTopC } from '../../../../core/helpers/skinHelper';
import { cryptoCurrencies } from '../../../../core/constants/cryptoCurrencies';

export const MARKET_TYPE = {
  Low: 0,
  High: 1,
  Equal: 2,
  Black: 3,
  Red: 4,
};

export const MARKET_TYPE_NAME = {
  Low: 'LOW',
  High: 'HIGH',
  Equal: 'SAME',
  Black: 'BLACK',
  Red: 'RED',
};

export const HILO_MARKET_NAME_BY_TYPE = {
  0: 'LOW',
  1: 'HIGH',
  2: 'EQUAL',
  3: 'BLACK',
  4: 'RED',
};

export const SELECTED_CARD_INDEX = {
  Left: 0,
  Middle: 1,
  Right: 2,
};

export const MAX_CARD_COUNT = 52;

export const DEFAULT_SELECTED_CARD_TYPE = 0;

export const HILO_GAME_ID = 40;

export const HILO_CARD_ANIMATION_DURATION = 240;

export const HiloLiveBetsColumns = [
  {
    title: TranslationKeys.UserId,
    dataKey: 'userId',
    isShow: true,
    columnType: ColumnsType.MaskNameFormat,
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const HiloBetHistoryColumns = [
  {
    title: TranslationKeys.RoundId,
    dataKey: 'id',
    isShow: true,
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo) => (
      <i
        onClick={(e) => {
          e.stopPropagation();
          popupStore.open({ name: PopupTypes.Fairness, spinInfo });
          checkHashStore.setSpinInfo({
            salt: spinInfo.salt,
            key: spinInfo.key,
            hash: spinInfo.hash,
          });
        }}
        className='icon-fairness-fill cpt-table-column-icon'
      />
    ),
  },
  {
    title: TranslationKeys.Time,
    dataKey: 'date',
    columnType: ColumnsType.DateFormat,
    isShow: !isMobile(),
  },
  {
    title: isMobile() ? TranslationKeys.Bet : TranslationKeys.BetAmount,
    dataKey: 'amount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
  {
    title: TranslationKeys.Market,
    dataKey: 'market_type',
    isShow: !isMobile(),
    columnType: ColumnsType.Default,
    colRenderer: (spinInfo, t) => {
      return (
        <span className='cpt-table-text'>
          {spinInfo.spinResults?.length > 1 ? (
            <span
              className='multi-selection'
              onClick={(e) => {
                e.stopPropagation();
                popupStore.open({ name: PopupTypes.Fairness, spinInfo });
                checkHashStore.setSpinInfo({
                  salt: spinInfo.salt,
                  key: spinInfo.key,
                  hash: spinInfo.hash,
                });
              }}
            >
              {t(TranslationKeys.MultiSelection)}
            </span>
          ) : (
            t(HILO_MARKET_NAME_BY_TYPE[spinInfo.spinResults[0].marketType])
          )}
        </span>
      );
    },
  },
  {
    title: TranslationKeys.Odds,
    dataKey: 'odd',
    isShow: true,
    columnType: ColumnsType.Default,
    additionalInfoRenderer: () => 'x',
  },
  {
    title: TranslationKeys.Payout,
    dataKey: 'winAmount',
    isShow: true,
    columnType: ColumnsType.ConvertType,
    additionalInfoRenderer: (spinInfo) =>
      isTopC() ? (
        <span className={`cpt-history-currency-icon ${cryptoCurrencies[spinInfo.currencyCode]}`} />
      ) : (
        <p>{userInfoStore.currencyCode}</p>
      ),
  },
];

export const HILO_RULES_KEYS = new Array(isPG() ? 43 : 11)
  .fill(null)
  .map((item, index) => index + 1);
export const HILO_ABOUT_HASH_KEYS = new Array(16).fill(null).map((item, index) => index + 1);
